// Technician-side onboarding-request actions (the public sign-up wizard talks
// to /onboarding/checkout|status directly, outside redux).
export const LIST_ONBOARDING_REQUESTS = 'LIST_ONBOARDING_REQUESTS';
export const STORE_ONBOARDING_REQUESTS = 'STORE_ONBOARDING_REQUESTS';
export const UPDATE_ONBOARDING_REQUEST = 'UPDATE_ONBOARDING_REQUEST';
export const ACTIVATE_ONBOARDING_REQUEST = 'ACTIVATE_ONBOARDING_REQUEST';
export const SEND_ONBOARDING_WELCOME = 'SEND_ONBOARDING_WELCOME';
